import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";

import endpoints from "../../endpoint";
import { getImageUrl } from "../../utils/helpFunction";

const PartnerDeals = () => {
  const [deals, setDeals] = useState([]);
  const [filteredDeals, setFilteredDeals] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchPartnerDeals = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    try {
      const response = await axios.get(
        `${endpoints.serverBaseUrl}api/partner/partner-deals/${user.userId}`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      // Set state with fetched deals
      setDeals(response.data.deals);
      setFilteredDeals(response.data.deals);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching partner deals:", error);
      setError("Failed to fetch deals.");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartnerDeals();
  }, []);

  // Handle Search Filtering
  useEffect(() => {
    const filtered = deals.filter(
      (deal) =>
        deal.name.toLowerCase().includes(search.toLowerCase()) ||
        deal.email.toLowerCase().includes(search.toLowerCase()) ||
        deal.mobile.includes(search)
    );
    setFilteredDeals(filtered);
  }, [search, deals]);

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        mt={2}
        // component={Paper}
        // elevation={3}
        sx={{ borderRadius: 2 }}
      >
        <TextField
          fullWidth
          variant="outlined"
          label="Search by Name, Email, or Mobile"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 2 }}
        />

        {loading ? (
          <Grid container justifyContent="center" sx={{ py: 4 }}>
            <CircularProgress />
          </Grid>
        ) : error ? (
          <Typography color="error" align="center">
            {error}
          </Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ bgcolor: "#1976D2" }}>
                <TableRow>
                  <TableCell sx={{ color: "#fff" }}>Name</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Email</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Mobile</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Category</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Amount</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Status</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Payment Proof</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredDeals.length > 0 ? (
                  filteredDeals.map((deal) => (
                    <TableRow key={deal._id} hover>
                      <TableCell>{deal.name}</TableCell>
                      <TableCell>{deal.email}</TableCell>
                      <TableCell>{deal.mobile}</TableCell>
                      <TableCell>{deal.category}</TableCell>
                      <TableCell>₹{deal.amountReceived}</TableCell>
                      <TableCell>{deal.status}</TableCell>
                      <TableCell>
                        {deal.paymentProof ? (
                          <a
                            href={getImageUrl(deal.publicId)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={getImageUrl(deal.publicId)}
                              alt="Payment Proof"
                              style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                                borderRadius: "5px",
                              }}
                            />
                          </a>
                        ) : (
                          "No Image"
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No deals found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Grid>
    </Grid>
  );
};

export default PartnerDeals;
